type ProtoTimestamp = {
  seconds: bigint;
  nanos: number;
};

export const protoTimestampToZonedDateTimeString = (
  timestamp: ProtoTimestamp | undefined,
): string | undefined => {
  if (!timestamp) return undefined;
  const millis = Number(timestamp.seconds) * 1000 + timestamp.nanos / 1000000;
  const isoString = new Date(millis).toISOString();
  return isoString.replace('Z', '[UTC]');
};
